import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const HubSpotFormBase = styled.div`
  label {
    font-weight: 600;
    font-size: 13px;
    color: ${theme.colors.darkBlues[100]};
    line-height: 18px;
    margin-bottom: 4px;
  }

  legend {
    color: ${theme.colors.darkBlues[90]};
    font-size: 13px;
    padding-bottom: 4px;
    line-height: 18px;
    font-weight: 400;
  }

  input {
    font-size: 16px;
    line-height: 24px;
    padding: 4px 8px;
    border-radius: 3px;
    border: 1px solid ${theme.colors.darkBlues[50]};
    outline: 0px;
  }

  input.invalid {
    border-color: ${theme.colors.reds[100]};
    box-shadow: 0 0 4px 1px ${theme.colors.reds[50]};
    background-color: ${theme.colors.reds[10]};
  }

  p {
    color: ${theme.colors.darkBlues[90]};
    font-size: 12px;
    line-height: 18px;
  }

  ul {
    list-style-type: none;
    padding-inline-start: 0px;
    margin: 4px 0 !important;
  }

  fieldset.form-columns-2 .hs-form-field {
    padding: 2px 0;

    ${theme.smallerThan.sm} {
      width: initial !important;
      float: initial !important;

      input {
        width: 95% !important;
      }
    }
  }

  .hs-error-msgs {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  .hs-error-msg {
    color: ${theme.colors.reds[100]};
  }

  li.hs-form-booleancheckbox {
    label {
      flex: 1 0 auto;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  input[type="checkbox"] {
    outline: none;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    height: 20px;
    margin: 4px 8px 4px 0px;
    width: 20px;
    background-color: white;
    border: 1px solid rgb(196, 197, 198);
    border-radius: 3px;
    box-shadow: rgb(216, 222, 225) 0px 1px 2px 0px inset;

    :checked {
      background-color: rgb(25, 121, 195);
      box-shadow: none;
    }
  }

  input[type="radio"] {
    margin-right: 8px;
  }

  input[type="submit"] {
    margin-top: 18px;
    outline: 0;
    cursor: pointer;
    font-size: ${theme.fontSizes[2]};
    line-height: ${theme.leading.normal};
    border-radius: 3px;
    -webkit-appearance: none;
    box-shadow: none;
    font-weight: 600;
    padding: ${theme.space[2]} ${theme.space[3]};
    color: ${theme.colors.white};
    background: ${theme.colors.blues[100]};
    border: 1px solid ${theme.colors.blues[100]};

    &:hover {
      background: ${theme.colors.blues[125]};
      border-color: ${theme.colors.blues[125]};
    }

    &:focus:not(:active) {
      background: ${theme.colors.blues[100]};
      box-shadow: 0 0 ${theme.space[1]} 1px ${theme.colors.blues[100]};
      border-color: ${theme.colors.blues[125]};
    }

    &:active {
      background: ${theme.colors.blues[75]};
      border-color: ${theme.colors.blues[75]};
    }

    &:disabled {
      cursor: not-allowed;
      color: ${theme.colors.darkBlues[75]};
      border: 1px solid ${theme.colors.darkBlues[10]};
      background: ${theme.colors.darkBlues[10]};
    }
  }

  .submitted-message {
    color: ${theme.colors.darkBlues[90]};
    font-size: 16px;
    line-height: 24px;
    margin-top: 18px;
  }
`;
